import PieChartComponent from '../utils/PieChartComponent';
import { getTotalsGraph } from '../DiscipleshipCharts';

const DiscipleshipSummaries = ({
  summaryLeadersForPieChart,
  summaryDisciplesForPieChart,
  summaryGroupsForPieChart,
}) => {
  return (
    <div className="chartSection">
      <PieChartComponent
        title="Líderes"
        data={summaryLeadersForPieChart}
        subtitle={`Total: ${getTotalsGraph(summaryLeadersForPieChart)}`}
        pieType="leader"
      />
      <PieChartComponent
        title="Discípulos"
        data={summaryDisciplesForPieChart}
        subtitle={`Total: ${getTotalsGraph(summaryDisciplesForPieChart)}`}
        pieType="disciple"
      />
      <PieChartComponent
        title="Grupos"
        data={summaryGroupsForPieChart}
        subtitle={`Total: ${getTotalsGraph(summaryGroupsForPieChart)}`}
        pieType="group"
      />
    </div>
  );
};

export default DiscipleshipSummaries;
